import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    SET_SSR_STATUS
    SET_LEAD_DETAILS
    SET_SCRAP_DATA_SUCCESS
    SET_SHOW_ANIMATION
`,
    {
        prefix: "scrapcars/"
    }
);
